import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { MapContainer, TileLayer } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { setRestaurantCenter } from '../../../redux/legacy/reducers/ducks/legacy/MainDuck';
import Markers from '../MapMarkers';
import styles from './Map.style';
import useDesktopCheck from '../../../util/hooks/UseDesktopCheck';
import useClasses from '../../../hooks/legacy/useClasses';

const center = [40.73061, -73.935242];

function Map({ list, isFullScreen, restaurantLandingPage }) {
  const classes = useClasses(styles);
  const dispatch = useDispatch();
  const isDesktop = useDesktopCheck();

  const { restaurantCenter } = useSelector(({ main }) => ({
    restaurantCenter: main.restaurantCenter,
  }));

  useEffect(() => () => dispatch(setRestaurantCenter(null)), [dispatch]);

  return (
    <MapContainer
      key={isFullScreen + isDesktop}
      className={classes.mapContainer}
      center={center}
      zoom={12}
      id="mapContainer"
      dragging={false}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Markers
        list={list}
        center={center}
        restaurantCenter={restaurantCenter}
        isFullScreen={isFullScreen}
        restaurantLandingPage={restaurantLandingPage}
      />
    </MapContainer>
  );
}

Map.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string,
      categories: PropTypes.arrayOf(PropTypes.string),
      city: PropTypes.string,
      delays: PropTypes.shape({
        takeout: PropTypes.number,
        delivery: PropTypes.number,
      }),
      description: PropTypes.string,
      distance: PropTypes.number,
      features: PropTypes.arrayOf(PropTypes.string),
      fees: PropTypes.arrayOf(PropTypes.string),
      id: PropTypes.number,
      keywords: PropTypes.arrayOf(PropTypes.string),
      location: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
      }),
      media: PropTypes.oneOfType([
        PropTypes.objectOf(PropTypes.string),
        PropTypes.arrayOf(PropTypes.string),
      ]),
      modes: PropTypes.shape({
        delivery: PropTypes.bool,
        reservations: PropTypes.bool,
        takeout: PropTypes.bool,
      }),
      name: PropTypes.string,
      phone: PropTypes.string,
      profile: PropTypes.string,
      state: PropTypes.string,
      text: PropTypes.objectOf(PropTypes.string),
      windows: PropTypes.shape({
        takeout: PropTypes.number,
        delivery: PropTypes.number,
      }),
      zipcode: PropTypes.string,
      price_level: PropTypes.number,
      user_attributes: PropTypes.shape({
        favorite: PropTypes.bool,
      }),
      ratings: PropTypes.shape({
        stars: PropTypes.string,
        reviews: PropTypes.string,
      }),
    })
  ).isRequired,
  isFullScreen: PropTypes.bool,
  restaurantLandingPage: PropTypes.bool,
};

Map.defaultProps = {
  isFullScreen: false,
  restaurantLandingPage: false,
};

export default Map;
